module.exports = __webpack_public_path__ + "img/11.8400245e.png";